import React, { useState, useEffect } from 'react';
import { Tabs, Loading, Empty, Picker, Popup, Tag } from 'react-vant';
import { ArrowLeft, ArrowDown, AwardO } from '@react-vant/icons';
import { useNavigate } from 'react-router-dom';
import request from '../../api/request';

const SportsRank = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [standings, setStandings] = useState([]);
  const [meets, setMeets] = useState([]);
  const [currentMeet, setCurrentMeet] = useState(null);
  const [showPicker, setShowPicker] = useState(false);
  const [events, setEvents] = useState([]);
  const [currentEvent, setCurrentEvent] = useState(null);
  const [showEventPicker, setShowEventPicker] = useState(false);

  useEffect(() => {
    fetchMeets();
  }, []);

  const fetchMeets = async () => {
    try {
      const [activeRes, archivedRes] = await Promise.allSettled([
        request.get('/sports/meets/', { params: { is_archived: false, page_size: 50 } }),
        request.get('/sports/meets/', { params: { is_archived: true, page_size: 50 } })
      ]);
      const activeList = activeRes.status === 'fulfilled' ? (activeRes.value?.items || []) : [];
      const archivedList = archivedRes.status === 'fulfilled' ? (archivedRes.value?.items || []) : [];
      
      const allMeets = [
        ...activeList,
        ...archivedList.filter(a => !activeList.some(act => act.id === a.id))
      ];

      setMeets(allMeets.map(m => ({
        text: m.is_archived ? `${m.name} (往届)` : m.name,
        value: m.id
      })));

      if (allMeets.length > 0) {
        const defaultMeet = allMeets.find(m => !m.is_archived) || allMeets[0];
        setCurrentMeet(defaultMeet);
        fetchEvents(defaultMeet.id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchEvents = async (meetId) => {
    try {
      const res = await request.get(`/sports/meets/${meetId}/events/`, { params: { page_size: 100 } });
      const items = res.items || [];
      setEvents(items.map(e => ({ text: e.name, value: e.id })));
      if (items.length > 0) {
        setCurrentEvent(items[0]);
        fetchRankings(meetId, items[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchRankings = async (meetId, eventId) => {
    setLoading(true);
    try {
      const res = await request.get(`/sports/results/rankings/${eventId}/`);
      setStandings(res.rankings || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getRankBadge = (rank) => {
    switch (rank) {
      case 1:
        return {
          bg: 'linear-gradient(135deg, #fa8c16 0%, #d97706 100%)',
          color: '#ffffff',
          shadow: '0 4px 10px rgba(245, 158, 11, 0.35)',
          emoji: '🥇'
        };
      case 2:
        return {
          bg: 'linear-gradient(135deg, #94a3b8 0%, #64748b 100%)',
          color: '#ffffff',
          shadow: '0 4px 10px rgba(148, 163, 184, 0.35)',
          emoji: '🥈'
        };
      case 3:
        return {
          bg: 'linear-gradient(135deg, #ea580c 0%, #c2410c 100%)',
          color: '#ffffff',
          shadow: '0 4px 10px rgba(234, 88, 12, 0.35)',
          emoji: '🥉'
        };
      default:
        return {
          bg: '#f1f5f9',
          color: '#64748b',
          shadow: 'none',
          emoji: null
        };
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--canvas-bg, #f8fafc)', paddingBottom: 60 }}>
      {/* 沉浸式星瀚空天蓝页眉 */}
      <div style={{
        background: 'linear-gradient(135deg, #055e43 0%, #076f51 50%, #0c8c68 100%)',
        padding: '44px 16px 20px',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* 装饰半透圆 */}
        <div style={{
          position: 'absolute', top: -30, right: -30,
          width: 140, height: 140, borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.08)'
        }} />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
          <div
            onClick={() => navigate(-1)}
            style={{
              width: 36, height: 36, borderRadius: '50%',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            <ArrowLeft color="#fff" fontSize={18} />
          </div>

          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: '#fff', letterSpacing: '-0.2px' }}>
              实时排行榜
            </h1>
            <p style={{ margin: '2px 0 0', fontSize: 11.5, color: 'rgba(255,255,255,0.85)', fontWeight: 400 }}>
              运动会单项战绩与实时积分榜
            </p>
          </div>

          <div style={{ width: 36 }} />
        </div>
      </div>

      {/* 过滤筛选条 */}
      <div style={{
        display: 'flex',
        padding: '12px 16px',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        gap: 10,
        position: 'sticky',
        top: 0,
        zIndex: 10,
        borderBottom: '1px solid #e2e8f0'
      }}>
        <div 
          onClick={() => setShowPicker(true)}
          style={{ 
            flex: 1.4,
            background: '#f8fafc',
            padding: '9px 12px',
            borderRadius: 12, 
            fontSize: 13,
            display: 'flex',
            justifyContent: 'space-between', 
            alignItems: 'center',
            border: '1px solid #e2e8f0',
            minWidth: 0,
            cursor: 'pointer'
          }}
        >
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', minWidth: 0 }}>
            <span style={{ marginRight: 4, flexShrink: 0 }}>🏆</span>
            <span style={{ color: '#056b4f', fontWeight: 700, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {currentMeet?.name || '选择运动会'}
            </span>
          </div>
          <ArrowDown style={{ fontSize: 11, color: '#056b4f', marginLeft: 4, flexShrink: 0 }} />
        </div>

        <div 
          onClick={() => setShowEventPicker(true)}
          style={{ 
            flex: 1,
            background: '#f8fafc',
            padding: '9px 12px',
            borderRadius: 12, 
            fontSize: 13,
            display: 'flex',
            justifyContent: 'space-between', 
            alignItems: 'center',
            border: '1px solid #e2e8f0',
            minWidth: 0,
            cursor: 'pointer'
          }}
        >
          <div style={{ flex: 1, overflow: 'hidden', display: 'flex', alignItems: 'center', minWidth: 0 }}>
            <span style={{ marginRight: 4, flexShrink: 0 }}>🏃</span>
            <span style={{ color: '#056b4f', fontWeight: 700, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {currentEvent?.text || currentEvent?.name || '选择项目'}
            </span>
          </div>
          <ArrowDown style={{ fontSize: 11, color: '#056b4f', marginLeft: 4, flexShrink: 0 }} />
        </div>
      </div>

      {/* 排行榜单内容 */}
      <div style={{ padding: '12px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <Loading type="spinner" color="#056b4f" vertical>加载排行榜中...</Loading>
          </div>
        ) : standings.length === 0 ? (
          <div style={{ padding: '60px 0' }}>
            <Empty description="暂无排名数据" />
          </div>
        ) : (
          <div style={{
            background: '#ffffff',
            borderRadius: 16,
            padding: '4px 16px',
            boxShadow: 'var(--shadow-card, 0 4px 16px rgba(15, 23, 42, 0.05))',
            border: '1px solid #f1f5f9'
          }}>
            {standings.map((item, idx) => {
              const rankBadge = getRankBadge(item.rank);
              const isLast = idx === standings.length - 1;
              return (
                <div 
                  key={idx}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '16px 0',
                    borderBottom: isLast ? 'none' : '1px solid #f1f5f9'
                  }}
                >
                  {/* 排名圆点 */}
                  <div style={{ 
                    width: 34, height: 34, borderRadius: '50%', 
                    background: rankBadge.bg,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: rankBadge.color, fontWeight: 800, fontSize: 14,
                    boxShadow: rankBadge.shadow,
                    flexShrink: 0
                  }}>
                    {item.rank}
                  </div>

                  {/* 学生信息 */}
                  <div style={{ flex: 1, marginLeft: 16, minWidth: 0 }}>
                    <div style={{ 
                      fontSize: 16, fontWeight: 700, color: '#0f172a',
                      overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                      display: 'flex', alignItems: 'center', gap: 6
                    }}>
                      <span>{item.student_name}</span>
                      {rankBadge.emoji && <span style={{ fontSize: 14 }}>{rankBadge.emoji}</span>}
                    </div>
                  </div>

                  {/* 成绩和积分 */}
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 17, fontWeight: 800, color: '#056b4f', lineHeight: 1.2 }}>
                      {item.performance || '0'}
                    </div>
                    {item.points > 0 && (
                      <span style={{
                        display: 'inline-block',
                        fontSize: 11,
                        color: '#00b578',
                        background: '#e8f9f0',
                        fontWeight: 700,
                        padding: '1px 8px',
                        borderRadius: 999,
                        marginTop: 4
                      }}>
                        +{item.points}分
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <Popup visible={showPicker} round position="bottom">
        <Picker
          title="选择运动会"
          columns={meets}
          onConfirm={(v, o) => {
            setCurrentMeet({ id: o.value, name: o.text });
            setShowPicker(false);
            fetchEvents(o.value);
          }}
          onCancel={() => setShowPicker(false)}
        />
      </Popup>

      <Popup visible={showEventPicker} round position="bottom">
        <Picker
          title="选择项目"
          columns={events}
          onConfirm={(v, o) => {
            setCurrentEvent({ value: o.value, text: o.text });
            setShowEventPicker(false);
            fetchRankings(currentMeet.id, o.value);
          }}
          onCancel={() => setShowEventPicker(false)}
        />
      </Popup>
    </div>
  );
};

export default SportsRank;
